import { PatientService } from 'src/services/patient.service'
import { TPatient } from 'src/types/patient'

export const downloadPatientReport = async ({
  projectId,
  patient,
  patientFollowupId,
}: {
  projectId: number
  patient: TPatient
  patientFollowupId?: number
}) => {
  if (!patientFollowupId) return
  const data = await PatientService.downloadPatientReport(projectId, patient.id, patientFollowupId)
  const blob = new Blob([data], { type: 'application/pdf' })
  const url = window.URL.createObjectURL(blob)
  const a = document.createElement('a')
  document.body.appendChild(a)
  a.href = url
  a.download = `curecall-${patient?.lastname}-${patient?.firstname}.pdf`
  a.click()
  setTimeout(() => {
    window.URL.revokeObjectURL(url)
    document.body.removeChild(a)
  }, 0)
}
